<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3>Drivers Daily Photos</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-checkbox
        v-model="query.flagged"
        color="primary"
        class="small-label"
        label=" Flagged Only"
      ></v-checkbox>
      <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_photos_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {
      rideTypes: null,
      items: ["Rejected", "Accepted", "All"],
    };
  },
  mounted: async function () {},
  methods: {
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
